<template>
  <div class="handle-report">
    <re-dialog :visible.sync="contact_show" :title="is_Empty(info.company_visit_record_id)?'填写出差报告':'出差报告详情'"
               width="700px">
      <el-form class="p30" :model="dict_form" :rules="dict_form_rules" ref="contactData">
        <el-row>
          <el-col :lg="24" :md="24" :sm="24" :xs="24">
            <el-form-item label="联系客户" label-width="100px" prop="company_id">
              <el-input v-model="company_name" disabled/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :lg="24" :md="24" :sm="24" :xs="24">
            <el-form-item label="拜访主题" label-width="100px" prop="topic">
              <el-select v-model="dict_form.topic" placeholder="请选择"
                         :disabled="!is_Empty(info.company_visit_record_id)">
                <el-option :label="i.name" :value="i.dict_data_value" v-for="i in company_visit_topic" :key="i.id"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :lg="24" :md="24" :sm="24" :xs="24">
            <el-form-item label="拜访场所" label-width="100px" prop="place">
              <el-select v-model="dict_form.place" placeholder="请选择"
                         :disabled="!is_Empty(info.company_visit_record_id)">
                <el-option :label="i.name" :value="i.dict_data_value" v-for="i in company_visit_place" :key="i.id"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :lg="24" :md="24" :sm="24" :xs="24">
            <el-form-item label="交通方式" label-width="100px" prop="transportation">
              <el-select v-model="dict_form.transportation" placeholder="请选择"
                         :disabled="!is_Empty(info.company_visit_record_id)">
                <el-option :label="i.name" :value="i.dict_data_value" v-for="i in transportation_list" :key="i.id"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :lg="24" :md="24" :sm="24" :xs="24">
            <el-form-item label="联系人" label-width="100px" prop="contact_person">
              <el-input v-model="dict_form.contact_person" :disabled="!is_Empty(info.company_visit_record_id)"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :lg="24" :md="24" :sm="24" :xs="24">
            <el-form-item label="联系时间" label-width="100px" prop="contact_time">
              <el-date-picker
                  v-model="dict_form.contact_time"
                  type="date"
                  disabled
                  unlink-panels
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="pickerOptions"
                  placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :lg="24" :md="24" :sm="24" :xs="24">
            <el-form-item label="联系内容" label-width="100px" prop="content">
              <el-input :disabled="!is_Empty(info.company_visit_record_id)" v-model="dict_form.content" type="textarea"
                        :rows="4" resize="none"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="fr ac jc" slot="footer" v-if="is_Empty(info.company_visit_record_id)">
        <el-button size="small" @click="submit">确认添加</el-button>
      </div>
    </re-dialog>
  </div>
</template>

<script>
let now = null;
let pre = null;
let time = null;
export default {
  name: "handleReport",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    info: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  watch: {
    value(n) {
      this.contact_show = n;
    },
    contact_show(n) {
      this.$emit('input', n);
    },
    info(n) {
      if (!this.is_Empty(n)) {
        this.company_name = n.company_name;
        this.dict_form.company_id = n.company_id;
        this.dict_form.contact_time = n.create_time;
      }
      if (!this.is_Empty(n.company_visit_record_id)) {
        this.getTravelReportDetail();
      }
    }
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > now || time.getTime() < pre;
        }
      },
      contact_show: false,
      company_name: "",
      dict_form: {
        company_id: "",//客户ID
        topic: "",//主题ID
        contact_person: "",//联系人
        contact_time: "",//联系时间
        place: "",//场所ID
        transportation: "",//交通方式
        content: "",//联系内容
      },
      dict_form_rules: {
        company_id: [{required: true, message: '请选择联系客户', trigger: 'blur'},],
        topic: [{required: true, message: '请选择拜访主题', trigger: 'blur'},],
        place: [{required: true, message: '请选择拜访场所', trigger: 'blur'},],
        transportation: [{required: true, message: '请选择交通方式', trigger: 'blur'},],
        contact_person: [{required: true, message: '请输入联系人', trigger: 'blur'},],
        contact_time: [{required: true, message: '请选择拜访时间', trigger: 'blur'},],
        content: [{required: true, message: '请输入联系内容', trigger: 'blur'},],
      },
      company_visit_topic: [],
      company_visit_place: [],
      transportation_list: []
    }
  },
  created() {
    this.getDicTypeList();
    this.contact_show = this.$props.value;
    now = new Date(this.formatDate(Date.now(), 'yyyy-MM-dd') + ' 23:59:59').getTime();
    pre = this.sub(new Date(this.formatDate(Date.now(), 'yyyy-MM-dd') + ' 00:00:00').getTime(), (7 * 24 * 60 * 60 * 1000))
  },
  methods: {
    submit() {
      let is_submit = false;
      this.$refs.contactData.validate((valid) => {
        if (!valid) {
          is_submit = true;
          return;
        }
      });
      if (is_submit) return;
      this.contact_show = false;
      this.addTravelReport();
    },
    //添加出差记录
    addTravelReport() {
      this.dict_form.id = this.$props.info.id;
      this.post("app/travelReport/fill", this.dict_form).then(res => {
        this.$message.success("已填写!");
        this.dict_form = {
          company_id: "",//客户ID
          topic: "",//主题ID
          contact_person: "",//联系人
          contact_time: "",//联系时间
          place: "",//场所ID
          transportation: "",//场所ID
          content: "",//联系内容
        }
        this.company_name = "";
        this.$emit('success', 'travelReport')
      })
    },
    getTravelReportDetail() {
      this.post("app/travelReport/getTravelReportDetail", {id: this.$props.info.id}).then(res => {
        let companyVisitRecordBean = res.data.companyVisitRecordBean;
        this.dict_form.company_id = companyVisitRecordBean.company_id;
        this.dict_form.topic = companyVisitRecordBean.topic;
        this.dict_form.contact_person = companyVisitRecordBean.contact_person;
        this.dict_form.contact_time = res.data.clock_in_time;
        this.dict_form.place = companyVisitRecordBean.place;
        this.dict_form.transportation = companyVisitRecordBean.transportation;
        this.dict_form.content = companyVisitRecordBean.content;
        this.dict_form = JSON.parse(JSON.stringify(this.dict_form))
        this.company_name = res.data.company_name;
      })
    },
    //获取拜访主题,拜访场所
    async getDicTypeList() {
      //拜访主题
      let obj = {
        page: -1,
        pageSize: -1,
        dict_type_value: "company_visit_topic"
      }
      let res = await this.post("admin/dict/getDicDataList", obj);
      this.company_visit_topic = res.data;
      //拜访场所
      obj.dict_type_value = "company_visit_place"
      res = await this.post("admin/dict/getDicDataList", obj)
      this.company_visit_place = res.data;
      obj.dict_type_value = 'transportation';
      res = await this.post("admin/dict/getDicDataList", obj)
      this.transportation_list = res.data;
    },
  }
}
</script>

<style scoped lang="scss">
.handle-report {
  .el-select, .el-date-editor, .el-autocomplete {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/page/me/travelReport/components/handleReport.vue